import BaseHelper from './moment-base';
import moment from 'moment';

export default class IsSameOrBefore extends BaseHelper {
  compute([dateA, dateB = moment()], { precision = 'milliseconds' } = {}) {
    super.compute(...arguments);
    if (!dateA) {
      return false; // Return false if dateA is missing
    }
    return moment(dateA).isSameOrBefore(moment(dateB), precision);
  }
}
